import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params} from '@angular/router';
import {HttpClientService} from '../../Services/http-client.service';
import {AppSettings} from '../../app-settings';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-adobe-redirect-new',
  templateUrl: './adobe-redirect-new.component.html',
  styleUrls: ['./adobe-redirect-new.component.css']
})
export class AdobeRedirectNewComponent implements OnInit {

	showError:boolean = false;

  constructor(private route: ActivatedRoute,private httpClientService: HttpClientService) { }

    ngOnInit()
    {
    	this.getURlParams();
    }

    getURlParams()
    {
    	 this.route.queryParams.subscribe((params: Params) => {
          if(params['redirect'])
          {
          	var redirectKey = params['redirect'];
            this.fetchRedirectURL(redirectKey);
          }
          else
          {
          	this.showError = true;
          }
       });
    }

    fetchRedirectURL(key){

      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + '/api/getRedirectEntry/' + key, headers).subscribe(
        (data) => {
          console.log(data);
            if(data != "" && data != null){
                var sessionCookie = this.getCookie('BREEZESESSION');
                var redirectURL = data['value'];
                if(sessionCookie !=''  && sessionCookie != null)
                {
                  if(redirectURL)
                  {
                    window.location.href = redirectURL +'?session='+sessionCookie;
                  }
                  else
                  {
                    this.showError=true;
                  }
                }
                else
                {
                  this.showError = true;
                }
            }
            else{
              console.log("Redirect url fetched from db is empty");
              this.showError = true;
            }

        }

        );

    }

    getCookie(cname)
    {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
    }
}
